import { render, staticRenderFns } from "./TipView.vue?vue&type=template&id=bc844248&scoped=true&"
import script from "./TipView.vue?vue&type=script&lang=js&"
export * from "./TipView.vue?vue&type=script&lang=js&"
import style0 from "./TipView.vue?vue&type=style&index=0&id=bc844248&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc844248",
  null
  
)

export default component.exports